<template>
  <div
    class="flex gap-x-2.5 rounded-xl border pt-2.5 pr-3.5 pb-3.5 pl-3.5"
    :class="
      dark ? 'border-white/20 text-white' : 'border-[#ebedef] text-gray-800'
    "
  >
    <component
      :is="kind === 'microphone' ? MicrophoneIcon : VideoCameraIcon"
      class="mt-[3px] size-[18px] shrink-0"
      :class="dark ? 'text-white' : 'text-gray-700'"
      aria-hidden="true"
    />
    <div class="min-w-0">
      <p class="text-[18px] leading-5 font-medium">{{ copy.title }}</p>
      <p class="mt-2 text-[14px] leading-[18px] font-medium">
        {{ copy.reason }}
      </p>
      <p class="mt-2 text-[14px] leading-[18px]">{{ copy.help }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { MicrophoneIcon, VideoCameraIcon } from '@dacr/icons'

const props = defineProps<{
  kind: 'microphone' | 'camera'
  dark?: boolean
}>()

const copy = computed(() =>
  props.kind === 'microphone'
    ? {
        title: 'Turn the mic on',
        reason: 'Dacr needs access to your microphone to analyze audio.',
        help: 'Click the microphone icon in your browsers navigation bar and enable access. Or go to your browser’s setting page.',
      }
    : {
        title: 'Turn the camera on',
        reason: 'Dacr needs access to your camera to capture visuals.',
        help: 'Click the camera icon in your browsers navigation bar and enable access. Or go to your browser’s setting page.',
      }
)
</script>
